import React from 'react';
import { RailsItemLabel } from '@sls-react/typings/services/rails/item';
import ItemLabelPillAuctionText from '@sls-react/components/ItemDetails/ItemLabelPillAuctionText';

interface Props {
  auctionEndedAt?: string;
  label: RailsItemLabel;
}

const ItemLabelPill: React.FC<Props> = ({ auctionEndedAt, label }) => (
  <div
    className="inline-flex self-center px-2 text-xs font-semibold rounded-full py-0.5 whitespace-nowrap"
    style={{ backgroundColor: label.color, color: label.text_color }}
  >
    {auctionEndedAt ? (
      <ItemLabelPillAuctionText label={label} auctionEndedAt={auctionEndedAt} />
    ) : (
      label.text
    )}
  </div>
);

export default ItemLabelPill;
